import axios from "axios";
import analytics from "../assets/JSONs/HRDemoData/analytics.json";
import engagement_analysis from "assets/JSONs/HRDemoData/engagement_analysis.json";
import happiness_score from "assets/JSONs/HRDemoData/happiness_score.json";
import hr_overview from "assets/JSONs/HRDemoData/hr_overview.json";
import assessment_score from "assets/JSONs/HRDemoData/assessment_score.json";
import store from "../store/store";

export const getOverview = async (
  token,
  adminCorporateId,
  timeRange, // New parameter for time range (e.g., "all", "custom")
  customDateRange,
  teamName,
  teamLocation
) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/assessment/overview/" +
          adminCorporateId +
          "/" +
          "overview",
        {
          params: {
            timeRange: timeRange,
            customDate: customDateRange,
            teamName,
            teamLocation,
            ...(timeRange === "custom" && Array.isArray(customDateRange)
              ? {
                  startDate:
                    customDateRange[0] instanceof Date
                      ? customDateRange[0].toISOString()
                      : customDateRange[0],
                  endDate:
                    customDateRange[1] instanceof Date
                      ? customDateRange[1].toISOString()
                      : customDateRange[1],
                }
              : {}),
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
};

export const getUserDetailsOverview = async (
  token,
  adminCorporateId,
  timeRange,
  location,
  teamType,
  customDateRange
) => {
  try {
    // Base URL
    let url = process.env.REACT_APP_SERVER_URI +
      `/api/overview/all?location=${location}&teamType=${teamType}&timeRange=${timeRange}`;

    // Add custom date range if timeRange is "custom" and dates are provided
    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue = startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue = endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(startValue)}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }

    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const getChallengeAnalysisData = async (
  token,
  timeRange,
  customDateRange
) => {
  try {
    let url = `${process.env.REACT_APP_SERVER_URI}/api/challenge/all?timeRange=${timeRange}`;

    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }
    const response = await axios.get(
      url,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  } catch (e) {
    console.error("Error fetching Challenge All Details:", e);
    throw e;
  }
};

export const getChallengeAllDetails = async (
  token,
  timeRange,
  customDateRange
) => {
  try {
    let url = `${process.env.REACT_APP_SERVER_URI}/api/user/challenge/details?timeRange=${timeRange}`;

    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }
    const response = await axios.get(url,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  } catch (e) {
    console.error("Error fetching Challenge All Details:", e);
    throw e;
  }
};

export const getLeaderboardData = async (
  token,
  challengeId,
  timeRange,
  customDateRange
) => {
  try {
    let url = `${process.env.REACT_APP_SERVER_URI}/api/challenge/${challengeId}?timeRange=${timeRange}`;

    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }

    const response = await axios.get(url,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  } catch (e) {
    console.error("Error fetching Challenge All Details:", e);
    throw e;
  }
};

export const getEventDetails = async (
  token,
  adminCorporateId,
  timeRange,
  customDateRange
) => {
  try {
    let url = `${process.env.REACT_APP_SERVER_URI}/api/workshopDetails/${adminCorporateId}?timeRange=${timeRange}`;

    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }

    const response = await axios.get(url,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return response;
  } catch (e) {
    console.error("Error fetching Challenge All Details:", e);
    throw e;
  }
};

export const getTeamLocationForFilter = async (token) => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI + `/api/teamLocation`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
};

export const getContentTrendsData = async (
  token,
  timeRange,
  location,
  teamType,
  customDateRange
) => {
  // The demo mode handling for content trends would need specific demo data.
  // For now, let's assume it always hits the API or you'll add demo data later.
  // if (store.getState().user.isDemoUser) {
  //   // Return demo content trends data
  //   // e.g., return { data: { result: demoContentTrendsData } };
  // } else {
  try {
    // Base URL
    let url = process.env.REACT_APP_SERVER_URI +
    `/api/overview/content?timeRange=${timeRange}&location=${location}&teamType=${teamType}`;

    // Add customDate if timeRange is "custom" and customDate is provided
    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }
    const response = await axios.get(
      url,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response; // The actual data is usually in response.data
  } catch (e) {
    // It's good practice to log the specific error 'e' instead of a generic 'error'
    console.error("Error fetching content trends:", e);
    throw e; // Re-throw the error so the calling function can handle it
  }
  // }
};

export const getFeedbackInfoByCorporateId = async (
  token,
  adminCorporateId,
  teamName,
  teamLocation,
  timeRange,
  customDateRange
) => {
  try {
    let url = `${process.env.REACT_APP_SERVER_URI}/api/feedbacks/${adminCorporateId}?timeRange=${timeRange}`
    const params = {};

    if (teamName && teamName.toLowerCase() !== "all") {
      url+=`&teamName=${teamName}`;
    }
    if (teamLocation && teamLocation.toLowerCase() !== "all") {
      url+=`&teamLocation=${teamLocation}`;
    }

    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }

    const response = await axios.get(url,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response;
  } catch (e) {
    console.error("Error in getFeedbackInfoByCorporateId:", e); // Corrected error logging
    throw e; // Re-throw to be caught by the calling component
  }
};

export const getSessionInfo = async (
  token,
  adminCorporateId,
  teamName,
  teamLocation,
  timeRange,
  customDateRange
) => {
  try {
    let url = `${process.env.REACT_APP_SERVER_URI}/api/sessionsInfo/${adminCorporateId}?timeRange=${timeRange}`
    if (teamName && teamName.toLowerCase() !== "all") {
      url+=`&teamName=${teamName}`;
    }
    if (teamLocation && teamLocation.toLowerCase() !== "all") {
      url+=`&teamLocation=${teamLocation}`;
    }

    if (timeRange === "custom" && customDateRange) {
      if (Array.isArray(customDateRange)) {
        const [startDate, endDate] = customDateRange;
        if (startDate && endDate) {
          const startValue =
            startDate instanceof Date ? startDate.toISOString() : startDate;
          const endValue =
            endDate instanceof Date ? endDate.toISOString() : endDate;
          url += `&startDate=${encodeURIComponent(
            startValue
          )}&endDate=${encodeURIComponent(endValue)}`;
        }
      } else {
        url += `&customDate=${encodeURIComponent(customDateRange)}`;
      }
    }
    // The backend for /api/sessionsInfo doesn't typically use a 'month' query param
    // when timeRange is 'all' or a year for the B2BSessionInfoData structure.
    // If specific monthly filtering for this data structure is needed,
    // the backend would need to support it, and then 'month' could be added to params here.

    const response = await axios.get(
      url,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return response;
  } catch (e) {
    console.error("Error fetching Session Info:", e); // More specific error message
    throw e; // Re-throw to be caught by the calling component
  }
};

export const getContent = async (
  token,
  adminCorporateId,
  timeRange,
  location,
  teamType
) => {
  if (store.getState().user.isDemoUser) {
    // Assuming 'year' should be a defined variable, e.g., from a state or a default.
    // For now, let's assume a default or it needs to be passed as an argument.
    // If 'year' is meant to be dynamic, it should be passed to this function.
    const yearForDemo = "2023"; // Example: Or get it from a reliable source
    // let result=hr_overview.getOverview[year][department].concat(hr_overview.getOverview[year][location],hr_overview.getOverview[year][gender])
    let result = hr_overview.getOverview[yearForDemo];
    return {
      data: {
        result: result,
        yearsArray: Object.keys(hr_overview.getOverview), // Or a static array if preferred
      },
    };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/overview/all?location=${location}&teamType=${teamType}&timeRange=${timeRange}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getAssessment = async (token, adminCorporateId, quizId) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI +
      "/api/assessment/getAssessment/" +
      adminCorporateId +
      "/" +
      quizId,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

export const getMentalHealthData = async (
  token,
  adminCorporateId,
  year,
  department,
  location,
  gender
) => {
  if (store.getState().user.isDemoUser) {
    const currentMonth = new Date().getMonth();
    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    let mentalHealthData = assessment_score.getMentalHealthData[year].graphData;

    if (year === "All Time") {
      const originalAllTimeData =
        assessment_score.getMentalHealthData["All Time"].graphData["All Time"];
      let allTimeData = JSON.parse(JSON.stringify(originalAllTimeData)); // Clone the data to avoid repeated subtraction

      let totalSubtractValues = {};
      allTimeData.forEach((item) => {
        totalSubtractValues[item.name] = 0;
      });

      for (let i = currentMonth; i < months.length; i++) {
        let monthData =
          assessment_score.getMentalHealthData["2024"].graphData[months[i]] ||
          [];
        monthData.forEach((item) => {
          totalSubtractValues[item.name] += item.value;
        });
      }

      allTimeData.forEach((item) => {
        item.value -= totalSubtractValues[item.name];
        if (item.value < 0) item.value = 0; // Ensure no negative values
      });

      mentalHealthData = { "All Time": allTimeData };
    }

    return {
      data: {
        graphData: mentalHealthData,
        yearArray: [2023, 2024],
      },
    };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/assessment/mentalHealth/" +
          adminCorporateId +
          "/" +
          year,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getStressChartData = async (token, adminCorporateId) => {
  if (store.getState().user.isDemoUser) {
    return { data: assessment_score.getStressChartData };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          "/api/assessment/stress/" +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getMentalScore = async (token, adminCorporateId) => {
  if (store.getState().user.isDemoUser) {
    return { data: assessment_score.getMentalScore };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/mentalScore/` +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const loadQuizNames = async (token) =>
  await axios.get(
    process.env.REACT_APP_SERVER_URI + `/api/assessment/quizData`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
export const getHappinessScore = async (token, adminCorporateId) => {
  if (store.getState().user.isDemoUser) {
    return { data: happiness_score.getHappinessScore };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/happinessScore/` +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getSentimentScore = async (token, adminCorporateId, year) => {
  if (store.getState().user.isDemoUser) {
    return { data: happiness_score.getSentimentScore[year] };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/sentiment/` +
          adminCorporateId +
          "/" +
          year,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const gethappinessScoreSplit = async (
  token,
  adminCorporateId,
  year,
  user
) => {
  if (store.getState().user.isDemoUser) {
    return { data: happiness_score.gethappinessScoreSplit };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/happinessScoreSplit/` +
          adminCorporateId +
          "/" +
          year,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getEmployeeMood = async (token, adminCorporateId, year, month) => {
  if (store.getState().user.isDemoUser) {
    return { data: happiness_score.getEmployeeMood[year][month] };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/employeeListing/` +
          adminCorporateId +
          "/" +
          year +
          "/" +
          month,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getEngagementByType = async (
  token,
  adminCorporateId,
  year,
  month
) => {
  if (store.getState().user.isDemoUser) {
    return { data: engagement_analysis.getEngagementByType[year][month] };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/engagementByType/` +
          adminCorporateId +
          "/" +
          year +
          "/" +
          month,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getMonthWiseEngagement = async (token, adminCorporateId, year) => {
  if (store.getState().user.isDemoUser) {
    return { data: engagement_analysis.getMonthWiseEngagement[year] };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/engagementSplit/` +
          adminCorporateId +
          "/" +
          year,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getTriviaLeaderboard = async (
  token,
  adminCorporateId,
  triviaType
) => {
  if (store.getState().user.isDemoUser) {
    return {
      data: analytics.getTriviaLeaderboard[triviaType.split(":")[0].trim()],
    };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/triviaLeaderboard/` +
          adminCorporateId +
          "/" +
          triviaType,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getEngagedDisengagedEmployee = async (
  token,
  adminCorporateId,
  year,
  month
) => {
  if (store.getState().user.isDemoUser) {
    return {
      data: engagement_analysis.getEngagedDisengagedEmployee[year][month],
    };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/engagedDisengagedEmployees/` +
          adminCorporateId +
          "/" +
          year +
          "/" +
          month,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getEngagementScore = async (token, adminCorporateId, user) => {
  if (store.getState().user.isDemoUser) {
    return { data: engagement_analysis.getEngagementScore };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/zen/engagementScore/` +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getSurveys = async (token, adminCorporateId) => {
  if (store.getState().user.isDemoUser) {
    return { data: analytics.getSurveys };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/surveyGraphFilter/` +
          adminCorporateId,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};

export const getSurveyContent = async (
  token,
  adminCorporateId,
  surveyType,
  date
) => {
  if (store.getState().user.isDemoUser) {
    return { data: analytics.getSurveyContent[surveyType][date] };
  } else {
    try {
      const response = await axios.get(
        process.env.REACT_APP_SERVER_URI +
          `/api/assessment/surveyGraphContent/` +
          adminCorporateId +
          "/" +
          surveyType +
          "/" +
          date,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response;
    } catch (e) {
      console.log(error);
      throw error;
    }
  }
};
